/*
 * @Author: Teemo Ding
 * @Date: 2021-09-06 09:59:35
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-04-28 15:30:36
 * @FilePath: /unifyxp-v2-store-portal/src/pages/StoreVoucher/List/index.tsx
 */

import Breadcrumb from '@/src/components/Antd/Breadcrumb/Breadcrumb';
import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import { MenuItemType } from '@/src/components/BulkEditor/BulkEditor';
import GlobalTable from '@/src/constrains/BulkEditorTable/BulkEditorTable2';
import { NEW } from '@/src/tools/constant';
import React, { memo, ReactNode, useState } from 'react';
import { Modal } from 'src/components/Antd';
import ListPageLayout from 'src/layout/ListPageLayout/ListPageLayout';
import { EnumStatus } from 'src/types/common/discount';
import { modal } from 'src/utils/Modal';
import css from './css.module.less';
// import {
//   activeChange, //setTableSetting
//   setAllDataTotal,
// } from './slice';
import { useHistory } from 'react-router';
import {
  archiveStoreVoucher,
  draftStoreVoucher,
  duplicateStoreVoucher,
  getVouchersList,
  getVouchersListPage,
  issueStoreVoucher,
  publishStoreVoucher,
} from 'src/request/voucher';
import { useAfterDidMountEffect } from 'src/tools/customHooks';

import { useQueries, useSelectRows } from '@/src/tools/hooks/listPageHooks';
import { get } from 'lodash';
import { defaultPageSize } from 'src/tools/constant';
import {
  // addButtonMenu,
  breadcrumbData,
  columns,
  filterList,
  ModalType,
  StatusChange,
  tabsConfig,
} from './config';
import { EPermissionSource } from 'src/types/common/resources';
import { storeResourceNameGenerator } from 'src/tools/getUserInfo';
import {
  EnumCategory,
  EnumSubCategory,
  EnumOperation,
} from 'src/types/common/resources';
import { isUserValid } from 'src/tools/getUserInfo';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, handleOnGetStoreTimezoneUTC } from 'src/tools/tools';

const flashSaleConvertQuery = (filter) => {
  //console.log('filter', filter);
  const re: any = {};
  if (filter.customerDatabaseUuid && filter.customerDatabaseUuid[0]) {
    re.customerDatabaseUuid = get(filter.customerDatabaseUuid[0], 'value');
  }
  if (filter.salesChannelUuids && filter.salesChannelUuids.length > 0) {
    re.salesChannelUuids = filter.salesChannelUuids.map((i) => i.value);
  }
  re.statusList = (filter.discountStatuses || []).map((status) => status.value);
  re.voucherTypes = (filter.discountTypes || []).map((status) => status.value);

  return re;
};

const StoreVoucherList = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const timezoneInUTC = handleOnGetStoreTimezoneUTC();
  const canAdd = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Voucher,
        subCategory: EnumSubCategory.StoreVoucher,
        operation: EnumOperation.add_edit_voucher,
      }),
    ],
  });

  const canChangeStatus = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Voucher,
        subCategory: EnumSubCategory.StoreVoucher,
        operation: EnumOperation.archive_publish_unpublish,
      }),
    ],
  });

  const history = useHistory();
  // const {
  //   // sort,
  //   // searchList: searchListArray,
  //   // filter,
  //  // tabsActive,
  //   allDataTotal,
  //   // tableSettings,
  // } = state;
  const [tabsActive, setTabActive] = React.useState('');
  const [dbs, setDbs] = React.useState([]);
  const [salesChannels, setSalesChannels] = React.useState([]);
  const [loading, setLoading] = useState(false);
  const [flashSales, setFlashSales] = useState([]);
  /* 分页 */
  const [current, setCurrent] = useState(0);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [sortBy, setSortBy] = useState<any>();

  const { clearSearchState, queryProps, search } = useQueries(
    filterList(tabsActive, dbs, salesChannels, { getI18n }),
    [],
    flashSaleConvertQuery,
  );

  /* 弹窗 */
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalTitle, setModalTitle] = useState<string | ReactNode>('');
  const [modalContent, setModalContent] = useState<ReactNode>('');

  /* 多选 */
  const {
    rowSelection,
    selectedRowKeys,
    selectedAll,
    setSelectedAll,
    setMappedSelectedKeys,
    //mappedSelectedKeys,
    setSelectedRowKeys,
  } = useSelectRows(flashSales);

  const addFun = () => {
    history.push(`/storeVoucherEdit/${NEW}`);
  };

  const statusChangeModal = (uuid, type: ModalType) => {
    const notAblePublishText = (
      <div>
        <div className={css.errorPublish}>
          {type == ModalType.ArchiveDiscount
            ? getI18n('voucher.storeVoucherDetail.deactivatediscount')
            : getI18n('voucher.storeVoucherDetail.fixallerrors')}
        </div>{' '}
        <ModalFooter
          onCancel={() => setShowModal(false)}
          okText={
            type == ModalType.ArchiveDiscount
              ? getI18n('general.archive')
              : getI18n('voucher.storeVoucherList.gotoedit')
          }
          onOk={() =>
            type == ModalType.ArchiveDiscount
              ? handleChangeStatus(uuid, StatusChange.Archive)
              : handleGotoEdit(uuid)
          }
        />
      </div>
    );
    setModalContent(notAblePublishText);
    setModalTitle(
      type == ModalType.ArchiveDiscount
        ? getI18n('voucher.storeVoucherList.archiveDiscount')
        : getI18n('voucher.storeVoucherList.unabletoPublish'),
    );
    setShowModal(true);
  };

  const buttonMenu = () => {
    let showSwitchDraft = false;
    if (selectedRowKeys.length > 0) {
      const selectedItems = flashSales.filter((o) =>
        selectedRowKeys.includes(o.uuid),
      );
      const selectedItemsStatus = selectedItems.map((item) => item.status);
      if (!selectedItemsStatus.includes(EnumStatus.Draft)) {
        showSwitchDraft = true;
      }
    }
    return [
      //Bulk Edit
      ...(tabsActive !== EnumStatus.Archived &&
      showSwitchDraft &&
      canChangeStatus
        ? [
            {
              key: 1,
              value: getI18n('general.switchToDraft'),
              type: MenuItemType.Primary,
              function: () =>
                handleChangeStatus(selectedRowKeys, StatusChange.ToDraft),
            },
          ]
        : []),
      // ...(tabsActive !== EnumStatus.Archived
      //   ? [
      //       {
      //         key: 2,
      //         value: getI18n('general.duplicate'),
      //         type: MenuItemType.Primary,
      //         function: () =>
      //           handleChangeStatus(selectedRowKeys, StatusChange.Duplicate),
      //       },
      //     ]
      //   : []),
      ...(tabsActive !== EnumStatus.Archived && canChangeStatus
        ? [
            {
              key: 3,
              value: getI18n('general.archive'),
              type: MenuItemType.Error,
              function: () =>
                statusChangeModal(selectedRowKeys, ModalType.ArchiveDiscount),
            },
          ]
        : []),
      ...(tabsActive == EnumStatus.Archived && canChangeStatus
        ? [
            {
              key: 4,
              value: getI18n('general.restore'),
              type: MenuItemType.Primary,
              function: () =>
                handleChangeStatus(selectedRowKeys, StatusChange.ToDraft),
            },
          ]
        : []),
    ];
  };

  //清除table状态
  const clearTableState = () => {
    setSelectedRowKeys([]);
    setMappedSelectedKeys([]);
    setSelectedAll(false);
  };

  //关闭弹窗
  const onModalCancel = () => {
    setShowModal(false);
  };

  //tab改变事件
  const tabChange = (activeKey) => {
    clearTableState();
    clearSearchState();
    setCurrent(0);
    setTabActive(activeKey);
  };
  //分页配置
  const paginationProps = {
    defaultPageSize: pageSize,
    showQuickJumper: true,
  };

  const getProduct = (cb) => {
    if (!loading) {
      setLoading(true);
    }
    // const data = search;
    const { statusList: searchList, ...rest } = search || {};

    const status =
      searchList && searchList.length > 0
        ? { statusList: searchList }
        : tabsActive
        ? { statusList: [tabsActive] }
        : {
            statusList: [
              EnumStatus.Active,
              EnumStatus.Draft,
              EnumStatus.Issued,
              //  EnumStatus.Scheduled,
              EnumStatus.Expired,
              //   EnumStatus.Archived,
            ],
          };
    const _data = { ...(rest || {}), ...status, sortBy };

    getVouchersList(
      {
        ..._data,
        // salesChannelUuid: salesChannelUuid,
        // firstRow: current * pageSize,
        // sizePerPage: pageSize,
      },
      current * pageSize,
      pageSize,
    ).then((res) => {
      //console.log(res);
      const { results, totalCount } = res;
      // const { salesChannelName } = res;
      //  const { totalCount, results } = res.result as any;
      setTotal(totalCount);
      //  setSalesChannelName(salesChannelName);
      setFlashSales(results);
      setLoading(false);
    });
  };

  React.useEffect(() => {
    const _data = {
      ...search,
      ...{
        statusList: [
          EnumStatus.Active,
          EnumStatus.Draft,
          EnumStatus.Issued,
          //  EnumStatus.Scheduled,
          EnumStatus.Expired,
          //   EnumStatus.Archived,
        ],
      },
      sortBy,
    };
    getVouchersListPage(
      {
        ..._data,
        // salesChannelUuid: salesChannelUuid,
        // firstRow: current * pageSize,
        // sizePerPage: pageSize,
      },
      current * pageSize,
      pageSize,
    ).then((res) => {
      const { customerDatabases, salesChannels } = res;
      setDbs(customerDatabases || []);
      setSalesChannels(salesChannels || []);
    });
    getProduct(() => void 0);
  }, []);

  useAfterDidMountEffect(() => {
    getProduct(() => void 0);
  }, [tabsActive, current]);

  useAfterDidMountEffect(() => {
    if (!current) {
      getProduct(() => void 0);
    } else {
      setCurrent(0);
    }
  }, [pageSize, search, sortBy]);

  const pageLayoutProps = {
    title: getI18n('general.sider.voucher'),
    // addButtonOverlay,
    addText: getI18n('voucher.storeVoucherList.addVoucher'),
    addFun: canAdd ? addFun : null,
    tabChange,
    activeKey: tabsActive,
    tabsConfig,
  };

  const handleGotoEdit = (uuid, disabled?) => {
    history.push(
      `/storeVoucherEdit/${uuid}${disabled ? '?disabled=' + disabled : ''}`,
    );
  };

  const handleChangeStatus = (uuids, type, canPublish?) => {
    // console.log('canPublish', canPublish);
    // console.log('type', type);
    if (canPublish === false && type == StatusChange.Publish) {
      statusChangeModal(uuids[0], ModalType.UnableToPublish);
    } else {
      const changeStatusRequestList = {
        [StatusChange.Publish]: publishStoreVoucher,
        [StatusChange.ToDraft]: draftStoreVoucher,
        [StatusChange.Archive]: archiveStoreVoucher,
        [StatusChange.Duplicate]: duplicateStoreVoucher,
        [StatusChange.Issue]: issueStoreVoucher,
      };
      changeStatusRequestList[type](uuids).then((res) => {
        //console.log(res);
        const { code, errMsg } = res;
        setShowModal(false);
        if (code === 400) {
          modal.error({
            title: getI18n('general.errorBoundary.error'),
            content: errMsg,
            onOkText: getI18n('general.confirm'),

            onOk: () => {
              return;
            },
          });
        } else {
          getProduct(() => void 0);
        }
      });
    }
  };

  return (
    <React.Fragment>
      <Breadcrumb
        className={css.breadcrumb}
        breadcrumbData={breadcrumbData({ getI18n })}></Breadcrumb>
      <ListPageLayout {...pageLayoutProps} tabChange={tabChange}>
        <GlobalTable
          id='ProductListTable'
          //onTableChange={setProducts}
          queryProps={queryProps}
          dataSource={flashSales}
          columns={columns(
            handleGotoEdit,
            handleChangeStatus,
            statusChangeModal,
            tabsActive,
            timezoneInUTC,
            { getI18n },
          )}
          selectedAll={selectedAll}
          setSelectedAll={setSelectedAll}
          buttonMenu={buttonMenu()}
          rowKey='uuid'
          pagination={paginationProps}
          current={current}
          setCurrent={setCurrent}
          pageSize={pageSize}
          setPageSize={setPageSize}
          total={total}
          rowSelection={rowSelection}
          selectedRowKeys={selectedRowKeys}
          hidePagination={total == 0}
          loading={loading}
          onChange={(_, s, sort) => {
            const asc = sort.order == 'ascend' ? true : false;
            const { field } = sort;
            setSortBy({ field, ascent: asc });
          }}
        />
      </ListPageLayout>
      <Modal
        width={600}
        visible={showModal}
        title={modalTitle}
        onCancel={onModalCancel}
        cancelText={getI18n('general.cancel')}>
        {modalContent}
      </Modal>
    </React.Fragment>
  );
};

export default memo(StoreVoucherList);
